<template>
  <q-dialog
    v-model="shown"
    data-test-id="select-role-permissions-dialog"
  >
    <q-card class="role-permissions-container">
      <q-card-section class="row items-center q-mx-xs">
        <div class="col">
          <div class="text-h6">
            Select Permissions for Role: {{ role.name || 'untitled' }}
          </div>
          <div class="text-subtitle text-grey-8">
            Selected {{ role.permissionActions.length }} of {{ permissions.data.length }}
          </div>
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section class="q-pt-none">
        <div class="row q-mb-sm no-wrap items-center">
          <div class="col">
            <q-input
              v-model.trim="searchString"
              label="Search"
              dense
              clearable
              debounce="300"
              :autofocus="!$q.platform.is.ios"
            />
          </div>
          <div class="col-auto q-ml-sm">
            <q-btn
              :label="$q.screen.gt.xs ? 'Toggle All' : 'All'"
              color="grey-8"
              flat
              dense
              :ripple="false"
              @click="toggleAllPermissions"
            />
          </div>
        </div>
        <div
          class="relative-position"
          style="min-height: 200px; max-height: 75vh; overflow: auto;"
        >
          <permissions-by-category-list
            :permissions="permissions.data"
            :selected-permission-actions="role.permissionActions"
            show-toggle-all
            @click-permission="toggleSinglePermission"
          />
          <q-inner-loading :showing="permissions.loading" />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import Role from 'src/models/access-control/Role'
import PermissionsByCategoryList from 'src/modules/admin/role/PermissionsByCategoryList'

export default {
  name: 'SelectRolePermissionsDialog',
  components: {
    PermissionsByCategoryList
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    role: {
      type: Role,
      required: true
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      searchString: '',
      shown: false
    }
  },
  watch: {
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    toggleAllPermissions () {
      const unselectedPermissions = _.filter(this.permissions.data, permission => _.includes(this.role.permissionActions, permission.action))
      if (unselectedPermissions.length > 0) {
        // None or only some selected, toggle unselected on
        _.each(unselectedPermissions, permission => this.role.togglePermission(permission))
      } else {
        // All permissions are selected, toggle all off
        _.each(this.permissions.data, permission => this.role.togglePermission(permission))
      }
    },

    toggleSinglePermission (permission) {
      this.role.togglePermission(permission)
    }
  },
  models: {
    permissions: {
      action: true,
      label: true,
      category: true,
      variables () {
        return {
          searchString: this.searchString
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.role-permissions-container {
  width: 650px;
  max-width: 900px;
}
</style>
